import type { ChecklistStatus as GeneratedChecklistStatus } from './generated/checklist-models';

export type ChecklistStatus = GeneratedChecklistStatus;

export const ChecklistStatus = {
  InProgress: 'InProgress' as ChecklistStatus,
  Completed: 'Completed' as ChecklistStatus,
  Discarded: 'Discarded' as ChecklistStatus,
} as const;

/** Finalization is terminal on the backend — any later write 409s — so no live push may leave it. */
export function isTerminalChecklistStatus(status: ChecklistStatus): boolean {
  return (
    status === ChecklistStatus.Completed || status === ChecklistStatus.Discarded
  );
}
